import { VOD_PLAYER_DOMAIN } from "constant/config";
import { isWebview, vodInflowLog, getStoryPlayerScheme } from "helpers";
import useSearchParams from "components/hook/useSearchParams";

import React, { useCallback } from "react";

const CatchStoryPostLink = ({ vod, inflowPaths, storyOrderInTotal, total, onClick = null, children}) => {

    // 검색 데이터 조회
    const { orderBy } = useSearchParams("catchstory");

    // VIN 쿠키저장 및 PC 진입 로그 (inflow_path) 전달
    const handleStoryVodInflowLog = useCallback(()=>{
        if (typeof onClick === "function") {
            onClick();
        }

        let appendData = {};
        appendData['story_no'] = vod.story_idx;

        vodInflowLog(vod.copyright_id, vod.title_no, inflowPaths, appendData);
    }, [inflowPaths, onClick, vod])

    if (isWebview) {
        // 앱내 웹뷰 - 앱내 Story 로 이동
        return (
            <a
                href={getStoryPlayerScheme(vod.story_idx, storyOrderInTotal, total, orderBy)}
                onClick={handleStoryVodInflowLog} 
            >
                {children}
            </a>
        );
    } else {
        return (
            <a
            href={`${VOD_PLAYER_DOMAIN}/${vod.story_idx}/catchstory?szLocation=station&szOrderBy=${orderBy}`}
            target="_blank"
            onClick={handleStoryVodInflowLog} 
            >
                {children}
            </a>
        );
    }

};

export default CatchStoryPostLink;
